import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Colors from '../../../../constants/Colors';

interface AssetCardFieldProps {
  title: string,
  value: string,
}

const AssetCardField = ({ title, value }: AssetCardFieldProps) => <View style={styles.container}>
  <Text style={styles.title}>{title}</Text>
  <Text style={styles.value} ellipsizeMode='tail'>
    {value?.length > 0 ? value : '-'}
  </Text>
</View>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  title: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginBottom: 4,
  },
  value: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack600,
    marginBottom: 12,
  },
});

export default AssetCardField;
